import request from "../utils/request";

export interface AskHistorySource {
  name: string;
  type: string;
  segment?: string;
}

export interface AskHistoryReasoningStep {
  step: number;
  content: string;
}

export interface AskHistoryListItem {
  id: string;
  /** 北京时间 yyyy-MM-dd HH:mm:ss */
  time: string;
  user: string;
  userId?: string;
  role?: string;
  /** sess-{xxxx} */
  sessionId: string;
  question: string;
  /** 秒，1 位小数 */
  responseTime: number;
}

export interface AskHistoryLog extends AskHistoryListItem {
  answer?: string;
  reasoning: AskHistoryReasoningStep[];
  sources: AskHistorySource[];
  summary?: string;
  executionMessage?: string;
}

export interface AskHistoryDetail {
  conversationId?: string;
  targetQuestionId: string;
  targetAnswerId?: string;
  logs: any[];
}

export interface AskHistorySummary {
  totalRequests: number;
  requestsPer5m: number;
  successRate: number;
  failureRate: number;
  avgResponseMs: number;
}

export interface PagedResult<T> {
  data: T[];
  total: number;
  page: number;
  pageSize: number;
}

export async function getAskHistoryLogs(params: {
  search?: string;
  page?: number;
  pageSize?: number;
} = {}): Promise<PagedResult<AskHistoryListItem>> {
  const query: Record<string, string> = {};
  if (params.search?.trim()) query.search = params.search.trim();
  if (params.page) query.page = String(params.page);
  if (params.pageSize) query.pageSize = String(params.pageSize);
  const res = await request.get<PagedResult<AskHistoryListItem>>("/project/askhistory/list", {
    params: Object.keys(query).length ? query : undefined,
  });
  return res.data ?? { data: [], total: 0, page: params.page ?? 1, pageSize: params.pageSize ?? 10 };
}

export async function getAskHistoryDetail(id: string): Promise<AskHistoryDetail> {
  const res = await request.get<AskHistoryDetail>(`/project/askhistory/${id}`);
  return res.data;
}

export async function getAskHistorySummary(): Promise<AskHistorySummary> {
  const res = await request.get<AskHistorySummary>("/project/askhistory/summary");
  return (
    res.data ?? {
      totalRequests: 0,
      requestsPer5m: 0,
      successRate: 0,
      failureRate: 0,
      avgResponseMs: 0,
    }
  );
}
